<div class="ahe-ui-alert-modal" id="previewModal" role="dialog" tabindex="-1">
    <div class="modal-overlay" id="previewModalOverlay">
        <div class="modal-container-new">
            <div class="modal-dialog-more-info-new">
                <div class="modal-content preview-content" [class.modifiePreviewdHeight]="isQuestionAddedRemoved">
                    <div class="modal-header-new">
                        {{header}}
                        <button aria-label="close dialog" class="close" data-dismiss="modal" type="button"
                            (click)="closePreviewModal()">
                            <span class="ahe-icon ahe-icon-close-white"></span>
                        </button>
                    </div>
                    <div class="marginAuto" *ngIf="isQuestionAddedRemoved && (beforeDroppedValue != previewData[0].dropped)">
                        <app-alert [smallAlert]="true" [type]="alertType.Success" (close)="closeSuccessAlert()">{{questionStatus}}</app-alert>
                    </div>
                    <div class="modal-body-new" *ngFor="let data of previewData; let i = index">
                        <div class="question-body">
                            <div class="question-sequence">
                                <div class="ml-3" ><strong>Question {{data.visibleIndex}}</strong>
                                    <app-alert [smallAlert]="true" [type]="alertType.Info" *ngIf="data.dropped" [closable]="false"  > {{questionInfoMessage}}</app-alert>
                                </div>
                            </div>
                            <div class="ml-4 mt-2" style="font-size: 18px">
                                <span><strong>{{type}}</strong></span>
                            </div>
                            <div class="ml-4 mt-2"><iframe
                                    [src]='data.onlinePreview|sanitizUrl'
                                    class="iframe-body-multiple preview-body" id="previewIframe"></iframe>
                            </div>
                        </div>
                        <div id="pagerWrapper" class="row h-20 justify-content-center align-items-center button-align"
                            style="padding-top: 8px;">
                            <app-pager [length]="dataLength" [pageIndex]="pageNumber" [pageSize]="itemsPerPage"
                                (page)="pageChanged($event)">
                            </app-pager>
                        </div>
                    </div>

                    <div class="modal-footer-new">
                        <app-button buttonText="Cancel" data-dismiss="modal" [purpose]="_buttonPurpose.Secondary"
                            class="align-left" (click)="closePreviewModal()"></app-button>
                        <app-button [disabled]="previewData[0].dropped" *ngIf="sourceLocationInfo == 'SourcePanel' " buttonText="Add question" data-dismiss="modal" [purpose]="_buttonPurpose.Primary"
                            class="align-left" (click)="addQuestion()"></app-button>
                            <app-button buttonText="Re-add question" *ngIf="previewData[0].isRemoved && previewData[0].dropped == false && sourceLocationInfo == 'RightPanel' " [purpose]="_buttonPurpose.Primary"
                            class="align-left" (click)="addQuestion()"></app-button>
                        <app-button [disabled]="!previewData[0].dropped" buttonText="Remove question" data-dismiss="modal" [purpose]="_buttonPurpose.Secondary" class="align-left" (click)="addQuestion()"></app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
